import {useState} from "react";
import styled from 'styled-components';
import {useHistory} from "react-router-dom";

import {Button, FormControl, FormLabel, Input, InputGroup, Stack} from "@chakra-ui/react";
import {Footer, Fullscreen, Main} from '../../components/fullscreen_view';
import Form from "../../components/form";
import useFeedback from "../../utils/use_feedback";
import ErrorMessage from "../../components/error_message";
import {FixedTopBar} from "../../components/top_bar";
import {useReset} from "../../api/reset";

const Description = styled.div``;

const Reset = styled(({className}) => {
    const history = useHistory();
    const {feedbackCh, error} = useFeedback(true);
    const [username, setUsername] = useState('');
    const [email, setEmail] = useState('')


    const handleUsername = (event) => setUsername(event.target.value)
    const handleEmail = (event) => setEmail(event.target.value)

    const [loading, setLoading] = useState(false);
    const reset = useReset(feedbackCh);
    const [page, setPage] = useState(1);
    const handleReset = async () => {
        if (page === 2) history.push('/');
        if (!email || !username) return;
        setLoading(true);
        try {
            await reset(username, email);
            setPage(2);
        } catch {
            // error will be displayed
        }
        setLoading(false);
    }

    return (
        <Fullscreen className={className}>
            <FixedTopBar back title="Reset Password" border={false}/>
            <Main>
                <Form autocomplete="off">

                    <Stack spacing={5}>

                        {page === 1 ?
                            <>
                                <Description>
                                    In order to reset your password, you must have an email address associated with your
                                    account.
                                </Description>

                                <FormControl>
                                    <FormLabel>Username</FormLabel>
                                    <Input type="text"
                                           maxLength="24"
                                           autoComplete="off"
                                           required
                                           onChange={handleUsername}
                                    />
                                </FormControl>

                                <FormControl>
                                    <FormLabel>Email Address</FormLabel>
                                        <Input type="text"
                                               autoComplete="off"
                                               required
                                               onChange={handleEmail}
                                        />
                                </FormControl>
                            </>
                            :
                            <Description>If the username and email address exist, we will send a reset link now. Check your spam folder.</Description>
                        }

                    </Stack>

                </Form>
            </Main>
            <Footer>
                <Button variant={"blue"} width={"100%"} onClick={handleReset} isLoading={loading}>{page === 1 ? 'Reset' : 'Go home'}</Button>
                <ErrorMessage error={error}/>
            </Footer>
        </Fullscreen>
    );
})`

  ${Form} {
    margin-top: 16px;
  }
  
  ${Footer} {
    width: calc(100% - 42px);
    margin: 0 auto;
  }
`;

export default Reset;
